import { FC } from "react";
import { IonNavLink } from '@ionic/react';
import { AllieNavLinkProps } from "./NavLink.types";

export const AllieNavLink: FC<AllieNavLinkProps> = (props : AllieNavLinkProps) => <IonNavLink {...props} />;
